import React from 'react';
import { Button, Container, Typography, Box, Paper, Stack } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { authAPI } from '../api';

// Inline Discord glyph (no official MUI icon)
function DiscordIcon(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden {...props}>
      <path d="M20.317 4.369a19.79 19.79 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.211.375-.445.865-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.6 12.6 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.1 13.1 0 0 1-1.872-.892.077.077 0 0 1-.008-.128c.126-.094.252-.192.372-.291a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.009c.12.099.246.198.373.292a.077.077 0 0 1-.006.127c-.598.35-1.22.645-1.873.892a.076.076 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.84 19.84 0 0 0 6.002-3.03.077.077 0 0 0 .032-.055c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.028zM8.02 15.331c-1.183 0-2.157-1.086-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.332-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.086-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.332-.946 2.418-2.157 2.418z" />
    </svg>
  );
}

function Login() {
  const handleLogin = () => {
    window.location.href = authAPI.loginUrl;
  };

  return (
    <Container maxWidth="xs">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        sx={{ py: 4 }}
      >
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            p: { xs: 3.5, sm: 4.5 },
            textAlign: 'center',
            borderRadius: 3,
            position: 'relative',
            overflow: 'hidden',
            background: 'linear-gradient(180deg, rgba(31,34,42,0.92), rgba(20,22,28,0.92))',
            border: '1px solid rgba(255,255,255,0.09)',
            boxShadow: '0 30px 70px rgba(0,0,0,0.55)',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '3px',
              background: 'linear-gradient(90deg, transparent, #D8352A, #C9A45C, transparent)',
            },
          }}
        >
          <Box
            sx={{
              display: 'inline-flex',
              p: 2,
              mb: 2,
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(216,53,42,0.20), transparent 70%)',
            }}
          >
            <img
              src="/dnd-logo.png"
              alt="D&D Logo"
              style={{ width: 76, height: 76, filter: 'drop-shadow(0 6px 18px rgba(216,53,42,0.55))' }}
            />
          </Box>

          <Typography variant="overline" sx={{ display: 'block', color: 'secondary.main', mb: 0.5, fontSize: '0.7rem' }}>
            Welcome to Azmar
          </Typography>

          <Typography variant="h3" component="h1" sx={{ fontSize: { xs: '2.1rem', sm: '2.5rem' }, mb: 1.5, color: 'text.primary' }}>
            D&amp;D Planner
          </Typography>

          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3.5, lineHeight: 1.6, maxWidth: 320, mx: 'auto' }}>
            For the boys.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            startIcon={<DiscordIcon />}
            onClick={handleLogin}
            sx={{ py: 1.35, fontSize: '1rem', fontWeight: 700 }}
          >
            Sign in with Discord
          </Button>

          <Stack direction="row" spacing={0.75} justifyContent="center" alignItems="center" sx={{ mt: 2.5 }}>
            <LockOutlinedIcon sx={{ fontSize: 14, color: 'text.secondary', opacity: 0.7 }} />
            <Typography variant="caption" sx={{ color: 'text.secondary', opacity: 0.8 }}>
              Secure sign-in via Discord OAuth
            </Typography>
          </Stack>
        </Paper>
      </Box>
    </Container>
  );
}

export default Login;
